import { ChangeEvent } from 'react';
import { handleTrack } from '../../utils/tracker';
import { TextInput } from '../Calculators/calculator-revamp/components/form-components/InputBox';
import { removeCommas } from '../Utils/CommonUtils';
import {
  leftDeductionDetails,
  rightDeductionDetails,
} from './tax-calculator-constants';
import { CALCULATOR_TAB_PROPS } from './types';
import { useDebouncedTaxCalculation } from './use-debounce-calcultion';

const Deductions = ({
  setGlobalError,
  setInputData,
  inputTabData,
  setTaxResult,
}: CALCULATOR_TAB_PROPS) => {
  const { setCurrentState } = useDebouncedTaxCalculation(
    inputTabData,
    setTaxResult
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setCurrentState(e.target.value);
    const key = e.target.id;
    const value = removeCommas(e.target.value);
    handleTrack({ label: `Deductions_${key}` });
    setInputData?.((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div className="flex gap-12 sm:block font-medium">
      <div className="w-full">
        {leftDeductionDetails?.map((props, index) => (
          <TextInput
            key={index}
            {...props}
            value={`${inputTabData?.[props.id]}` || ''}
            setGlobalError={setGlobalError}
            onTextChangeFn={handleChange}
          />
        ))}
      </div>
      <div className="w-full font-medium">
        {rightDeductionDetails?.map((props, index) => (
          <TextInput
            key={index}
            {...props}
            value={`${inputTabData?.[props.id]}` || ''}
            setGlobalError={setGlobalError}
            onTextChangeFn={handleChange}
          />
        ))}
      </div>
    </div>
  );
};

export default Deductions;
